import React, { useState, useEffect } from "react";
import * as Icon from "react-feather";
import { history } from "../../../helpers/history";
import { useDispatch, useSelector } from "react-redux";
import {
  listPolicies,
  listPolicyArchives,
  resetPolicyDetails,
} from "../Policy/PolicyActions";
import { getNotification } from "../../components/header/notificationActions";
import Pagination from "../../components/Pagination/Pagination";
import $ from "jquery";
import "./Policy.css";
import { PdfGeneration } from "../../pages/pdfGeneration/pdfActions";
import { CustomerId } from "src/app/config";
import SearchBox from "src/app/components/SearchBox";

const Policy = () => {
  const [isAdmin] = useState(localStorage.getItem("isAdmin"));
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const dispatch = useDispatch();
  const [sortParams, setSortParams] = useState({
    sortBy: "ASC",
    sortTitle: "policyRefId",
  });
  const [showArchives, setShowArchives] = useState(false);

  const policyList = useSelector((state) => state.policyData);
  const policyListData =
    policyList && policyList.policiesList && policyList.policiesList.data;
  const totalCount =
    policyList &&
    policyList.policiesList &&
    policyList.policiesList.policyCount;
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    window.onbeforeunload = null;
    // Listing Policies
    getPolicyList();
    getNotificationsList();
  }, [searchValue]);

  const generatePdf = (id) => {
    const data = {
      type: "policy",
      id: id,
    };
    dispatch(PdfGeneration(data));
  };
  const getNotificationsList = () => {
    const data = {
      numPerPage: 10,
      page: 1,
      customerId: CustomerId,

      userId: localStorage.getItem("userId"),
    };
    dispatch(getNotification(data));
  };

  const getPolicyList = (page = 1, pageSize = 100) => {
    const data = {
      numPerPage: pageSize,
      page: page == 0 ? 1 : page,
      sortKey: sortParams.sortTitle,
      sortType: sortParams.sortBy,
      searchKey: searchValue,
    };
    dispatch(listPolicies(data));
  };

  const onPageChanged = (data) => {
    if (data && data.currentPage == currentPageNumber) {
      return;
    }
    if (data && data.currentPage) {
      const { currentPage } = data;
      setCurrentPageNumber(currentPage);
      if (showArchives == false) {
        getPolicyList(currentPage);
      } else if (showArchives == true) {
        getArchivesList(currentPage);
      }
    }
  };

  const goToEditPolicy = (data) => {
    history.push("/home/addJobTicket", {
      type: 3,
      id: data.id,
      jobId: data.Policy.Ticket.id,
    });
  };

  const sortTable = (title) => {
    var sortByOrder = "ASC";

    if (title == sortParams.sortTitle) {
      sortByOrder = sortParams.sortBy == "DESC" ? "ASC" : "DESC";
      setSortParams({ sortBy: sortByOrder, sortTitle: title });
    } else {
      setSortParams({ sortBy: "ASC", sortTitle: title });
    }

    // Call Api here for sorting
    const data = {
      numPerPage: 100,
      page: currentPageNumber,
      sortKey: title,
      sortType: sortByOrder,
      searchKey: searchValue,
    };
    if (showArchives == false) {
      dispatch(listPolicies(data));
    } else if (showArchives == true) {
      dispatch(listPolicyArchives(data));
    }
  };

  const copyToClipboard = (data) => {
    const url = data;
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val(url).select();
    document.execCommand("copy");

    $temp.remove();
    window.open(url, "_blank", "noreferrer");
  };

  const goToCreatePolicy = () => {
    history.push("/home/addJobTicket", { type: 3 });
  };

  const getArchivesList = (page = 1, pageSize = 100) => {
    const data = {
      numPerPage: pageSize,
      page: page == 0 ? 1 : page,
      sortKey: sortParams.sortTitle,
      sortType: sortParams.sortBy,
      searchKey: "",
    };
    dispatch(listPolicyArchives(data));
  };

  const goToArchives = () => {
    dispatch(resetPolicyDetails());
    getArchivesList();
    setShowArchives(true);
  };

  const goToPolicies = () => {
    dispatch(resetPolicyDetails());
    getPolicyList();
    setShowArchives(false);
  };
  const handleSearch = (value) => {
    setSearchValue(value);
  };

  return (
    <div>
      <div className="d-flex justify-content-between">
        <div className="st-tl">
          <h1 className="mh-head-txt pt-3">
            {showArchives == false ? "Policies" : "Archives"}
          </h1>
        </div>
        {showArchives == false && isAdmin == "false" && (
          <div className="aad-usr pt-3">
            <Icon.PlusCircle />
            <a className="a-removed-href-create" onClick={goToCreatePolicy}>
              Create new Job Ticket for Policy
            </a>
          </div>
        )}
      </div>
      <hr className="pb-3" />

      <div className="d-flex justify-content-between mt-5 row">
        <div class="input-group st-tl col-md-4">
          <SearchBox onSearch={handleSearch} />
        </div>
        <div className="aad-usr pt-3 pr-3">
          {showArchives == false ? (
            <div>
              {" "}
              <Icon.Calendar />
              <a className="a-removed-href-create" onClick={goToArchives}>
                Archives
              </a>
            </div>
          ) : (
            <a className="a-removed-href-create" onClick={goToPolicies}>
              Go back to Policies
            </a>
          )}
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12">
          <div className="table-wraper table-responsive mnt mt-3">
            <table className="table job-list">
              <thead>
                <tr>
                  <th
                    scope="col"
                    className="mx-width"
                    onClick={() => {
                      sortTable("policyRefId");
                    }}
                  >
                    <div class="d-flex justify-content-start">
                      <div>Doc ID</div>
                      <div class="sort-wrp ml-2">
                        <i
                          class={
                            sortParams.sortTitle == "policyRefId" &&
                            sortParams.sortBy == "ASC"
                              ? "fa fa-sort-asc fa-lg active sort_up"
                              : "fa fa-sort-asc fa-lg sort_fade_down"
                          }
                        ></i>
                        <i
                          class={
                            sortParams.sortTitle == "policyRefId" &&
                            sortParams.sortBy == "ASC"
                              ? "fa fa-sort-desc fa-lg sort_fade_down"
                              : sortParams.sortTitle == "policyRefId" &&
                                sortParams.sortBy == "DESC"
                              ? "fa fa-sort-desc fa-lg active sort_up"
                              : "fa fa-sort-desc fa-lg sort_fade_down"
                          }
                        ></i>
                      </div>
                    </div>
                  </th>{" "}
                  <th
                    scope="col"
                    onClick={() => {
                      sortTable("policyName");
                    }}
                  >
                    <div className="d-flex justify-content-start">
                      <div>Policy Name</div>
                      <div className="sort-wrp ml-2">
                        <i
                          className={
                            sortParams.sortTitle == "policyName" &&
                            sortParams.sortBy == "ASC"
                              ? "fa fa-sort-asc fa-lg active sort_up"
                              : "fa fa-sort-asc fa-lg sort_fade_down"
                          }
                        ></i>
                        <i
                          className={
                            sortParams.sortTitle == "policyName" &&
                            sortParams.sortBy == "ASC"
                              ? "fa fa-sort-desc fa-lg sort_fade_down"
                              : sortParams.sortTitle == "policyName" &&
                                sortParams.sortBy == "DESC"
                              ? "fa fa-sort-desc fa-lg active sort_up"
                              : "fa fa-sort-desc fa-lg sort_fade_down"
                          }
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th
                    scope="col text-center"
                    onClick={() => {
                      sortTable("revision");
                    }}
                  >
                    <div class="d-flex justify-content-start">
                      <div>Revision</div>
                      <div class="sort-wrp ml-2">
                        <i
                          class={
                            sortParams.sortTitle == "revision" &&
                            sortParams.sortBy == "ASC"
                              ? "fa fa-sort-asc fa-lg active sort_up"
                              : "fa fa-sort-asc fa-lg sort_fade_down"
                          }
                        ></i>
                        <i
                          class={
                            sortParams.sortTitle == "revision" &&
                            sortParams.sortBy == "ASC"
                              ? "fa fa-sort-desc fa-lg sort_fade_down"
                              : sortParams.sortTitle == "revision" &&
                                sortParams.sortBy == "DESC"
                              ? "fa fa-sort-desc fa-lg active sort_up"
                              : "fa fa-sort-desc fa-lg sort_fade_down"
                          }
                        ></i>
                      </div>
                    </div>
                  </th>{" "}
                  <th
                    scope="col"
                    onClick={() => {
                      sortTable("updatedAt");
                    }}
                  >
                    <div className="d-flex justify-content-start">
                      <div>Date</div>
                      <div className="sort-wrp ml-2">
                        <i
                          className={
                            sortParams.sortTitle == "updatedAt" &&
                            sortParams.sortBy == "ASC"
                              ? "fa fa-sort-asc fa-lg active sort_up"
                              : "fa fa-sort-asc fa-lg sort_fade_down"
                          }
                        ></i>
                        <i
                          className={
                            sortParams.sortTitle == "updatedAt" &&
                            sortParams.sortBy == "ASC"
                              ? "fa fa-sort-desc fa-lg sort_fade_down"
                              : sortParams.sortTitle == "updatedAt" &&
                                sortParams.sortBy == "DESC"
                              ? "fa fa-sort-desc fa-lg active sort_up"
                              : "fa fa-sort-desc fa-lg sort_fade_down"
                          }
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th className="text-center" scope="col">
                    Download
                  </th>
                  {showArchives == false && isAdmin == "false" && (
                    <th className="text-center" scope="col">
                      Share
                    </th>
                  )}
                  {showArchives == false && isAdmin == "false" && (
                    <th className="text-center" scope="col">
                      Change Request
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {policyList && !policyList.loading && policyList.error && (
                  <span className="text-danger">ERROR: {policyList.error}</span>
                )}
                {policyListData &&
                  policyListData.map((policy, index) => (
                    <tr>
                      <td className="mx-width">{policy.policyRefId}</td>
                      <td>{policy.policyName}</td>
                      <td className="text-center">{policy.revision}</td>
                      <td>
                        {policy.updatedAt
                          ? policy.updatedAt.split("T")[0]
                          : "Not Approved"}{" "}
                      </td>
                      <td class="text-center">
                        {policy.policyType == "upload" ? (
                          <a href={policy.fileName} className="a-removed-href">
                            <Icon.Download />
                          </a>
                        ) : (
                          <a
                            className="a-removed-href"
                            onClick={() => generatePdf(policy.id)}
                          >
                            <Icon.Download />
                          </a>
                        )}
                      </td>
                      {showArchives == false && isAdmin == "false" && (
                        <td className="text-center">
                          <a
                            className="a-removed-href"
                            onClick={() => copyToClipboard(policy.fileName)}
                          >
                            <Icon.Share />
                          </a>
                        </td>
                      )}
                      {showArchives == false && isAdmin == "false" && (
                        <td className="text-center">
                          <a
                            className="a-removed-href"
                            onClick={() => goToEditPolicy(policy)}
                          >
                            Raise Ticket
                          </a>
                        </td>
                      )}
                    </tr>
                  ))}
              </tbody>
            </table>
            {policyList.policiesList.policyCount <= 0 && (
              <p className="text-center font-italic font-weight-bold">
                No data available!
              </p>
            )}
            {policyList.policiesList.policyCount > 0 && (
              <div className="d-flex flex-row py-4 align-items-center float-left">
                Total Count: {policyList.policiesList.policyCount}
              </div>
            )}

            <div className="d-flex flex-row py-4 align-items-center float-right">
              {policyList.policiesList.policyCount > 0 && (
                <Pagination
                  totalRecords={totalCount}
                  pageLimit={100}
                  pageNeighbours={0}
                  onPageChanged={onPageChanged}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Policy;
